/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

// TODO: Add an explanation for this
const selectDomain = (state: RootState) =>
  state?.OnBoardingState || initialState;

export const selectProfileForm = createSelector(
  [selectDomain],
  (state) => state.profileForm
);

export const selectSetupForm = createSelector(
  [selectDomain],
  (state) => state.setupForm
);
export const selectIsLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading
);

export const selectOnboardingList = createSelector(
  [selectDomain],
  (state) => state.onboardingList
);
export const selectTeamFormActiveIndex = createSelector(
  [selectDomain],
  (state) => state.teamFormActiveIndex
);
export const selectTeamForm = createSelector(
  [selectDomain],
  (state) => state.teamForm
);

export const selectTeamProjectName = createSelector(
  [selectDomain],
  (state) => state.teamForm.project.name
);

export const selectTeamProjectDefaultCustomization = createSelector(
  [selectDomain],
  (state) => state.teamForm.project.defaultCustomization
);

export const selectInviteVerification = createSelector(
  [selectDomain],
  (state) => state.inviteVerification
);
export const selectIsButtonLoading = createSelector(
  [selectDomain],
  (state) => state.isButtonLoading
);

